import z from "zod";

export const DataListOptionGroupSchema = z.object({
    "@id": z.string().optional(),
    "@type": z.string().optional(),
    id: z.number(),
    label: z.string(),
    color: z.string().nullable().optional(),
});

export const DataListOptionSchema = z.object({
    id: z.number(),
    code: z.string(),
    value: z.string(),
    label: z.string(),
    position: z.number(),
    optionGroup: z.union([DataListOptionGroupSchema, z.string()]).nullish(),
});

export const DataListVersionSchema = z.object({
    id: z.number(),
    title: z.string(),
    options: DataListOptionSchema.array(),
    source: z.string().optional(),
    versionMajor: z.number(),
    versionMinor: z.number(),
    status: z.number(),
});

const IndicatorSchema = z.object({
    code: z.string(),
});

export const DataListSchema = z.object({
    id: z.number(),
    code: z.string(),
    options: DataListOptionSchema.array().default([]),
    versions: DataListVersionSchema.array().default([]),
    indicators: IndicatorSchema.array().default([]),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional(),
    createdBy: z.string().optional(),
    updatedBy: z.string().optional(),
});

export type DataListOption = z.infer<typeof DataListOptionSchema>;
export type DataListOptionGroup = z.infer<typeof DataListOptionGroupSchema>;
export type DataListVersion = z.infer<typeof DataListVersionSchema>;
export type DataList = z.infer<typeof DataListSchema>;
